import React from "react";

export const RequireField: React.VFC = () => (
  <span role="presentation" aria-hidden="false" className="require-field">
    *
  </span>
);
